module.exports = __webpack_public_path__ + "static/space-galaxy-a50336327d8495cca6e52a101a557091.svg";